import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

function HitsAnnouncement ({ count }) {
  const hitRef = useRef(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (hitRef.current) {
      hitRef.current.focus()
    }
  }, [count])

  if (count === -1) return null

  return (
    <span
      ref={hitRef}
      role='status'
      aria-live='polite'
      aria-atomic='true'
      tabIndex='-1'
      aria-label={t('results_found', { count })}
    />
  )
}

export default HitsAnnouncement
